const noticeItems = [
  {
    id: "n1",
    icon: "ri-file-list-3-line",
    title: "资料性质说明",
    desc: "本页是对「三上悠亚电影」相关浏览方向的资料性整理，内容以介绍作品类型、合集组织方式与浏览思路为主，不提供也不托管任何影音资源。",
  },
  {
    id: "n2",
    icon: "ri-shield-check-line",
    title: "条目解释说明",
    desc: "页面中的类型、编号、时段与篇幅均为帮助理解与检索的一般性描述，用于区分不同方向，不代表任何官方数据或权威结论。",
  },
  {
    id: "n3",
    icon: "ri-parent-line",
    title: "浏览提示",
    desc: "本站面向成年浏览者，未成年人请勿访问相关主题内容。请在符合所在地法律法规与平台规则的前提下浏览。",
  },
];

export default function Notice() {
  return (
    <section id="notice" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <div className="rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
              <i className="ri-error-warning-line text-xl"></i>
            </span>
            <h2 className="font-heading text-xl font-semibold text-foreground-950">说明与浏览提示</h2>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {noticeItems.map((item) => (
              <div key={item.id} className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
                <div className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-600">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}